































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminInvoiceForm from '@/modules/invoice/components/admin/AdminInvoiceForm.vue'
import AdminInvoiceItemForm from '@/modules/invoice-item/components/admin/AdminInvoiceItemForm.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import { InvoiceResourceTypeInAdmin, InvoiceStatus } from '@/modules/invoice/models/invoice-reource.model'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import { InvoiceEditUseCase } from '@/modules/invoice/use-cases/admin/invoice-edit.use-case'
import AdminInvoiceShowTabular from '@/modules/invoice/components/admin/AdminInvoiceShowTabular.vue'
import AdminInvoiceShowSideNavigation from '@/modules/invoice/components/admin/AdminInvoiceShowSideNavigation.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import AdminInvoiceItemTable from '@/modules/invoice-item/components/admin/table/AdminInvoiceItemTable.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import AdminInvoiceItemFormTable from '@/modules/invoice-item/components/admin/table/AdminInvoiceItemFormTable.vue'
import AdminDownloadInvoiceButton from '@/modules/invoice/components/admin/AdminDownloadInvoiceButton.vue'
import AdminInvoiceBillingInfoTable
  from '@/modules/invoice/components/admin/billing-info-table/AdminInvoiceBillingInfoTable.vue'
import { AdminInvoiceService } from '@/modules/invoice/services/admin-invoice.service'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'فاکتور'
  },
  metaInfo: {
    title: 'فاکتور'
  },
  components: {
    AdminInvoiceBillingInfoTable,
    AdminDownloadInvoiceButton,
    AdminInvoiceItemFormTable,
    SimpleHeader,
    AdminInvoiceItemTable,
    AdminUserInfoButton,
    AdminInvoiceShowSideNavigation,
    AdminInvoiceShowTabular,
    BaseCard,
    BaseInput,
    AdminInvoiceItemForm,
    AdminInvoiceForm,
    BaseButton,
    PriceView,
    Toggle
  }
})
export default class ShowPage extends Vue {
  constructor(
    private readonly invoiceEditUseCase: InvoiceEditUseCase,
    private readonly service: AdminInvoiceService
  ) {
    super()
  }

  @Prop() invoiceData!: InvoiceResourceTypeInAdmin
  invoice: InvoiceResourceTypeInAdmin = this.initData()

  initData() {
    return this.invoiceData
  }

  get isEditable(): boolean {
    return (this.invoice.data.create_by_admin === true
      && (this.invoice.data.status === InvoiceStatus.UNPAID)
    )
  }

  onSubmit() {
    this.invoiceEditUseCase.execute(this.invoice.data.id, this.invoice.data)
  }

  onDestroy() {
    this.service.destroy(this.invoice.data.id)
  }

}
